import React from 'react';
import { Box, Checkbox, Divider, FormControlLabel, FormGroup, Paper, Typography } from '@mui/material';
import { CompanyMarket } from '../companyProfileApi';
import { MARKET_REGIONS, MarketRegionEnum } from '../marketRegion';
import { Localized } from '@fluent/react';

export interface MarketRegionMultiSelectProps {
    value: CompanyMarket[] | null;
    onChange: (markets: CompanyMarket[]) => void;
    companyProfileId: number;
}

export const MarketRegionMultiSelect: React.FC<MarketRegionMultiSelectProps> = ({
    value,
    onChange,
    companyProfileId,
}) => {
    const markets = value ?? [];

    // Helper to check if a region is selected
    const isRegionSelected = (regionEnum: MarketRegionEnum): boolean => {
        const regionId = Number(regionEnum);
        return markets.some(m => m.regionId === regionId || m.region === regionEnum);
    };

    const handleChange = (regionEnum: MarketRegionEnum, checked: boolean) => {
        const regionId = Number(regionEnum);

        if (checked) {
            // Add if it doesn't exist
            if (isRegionSelected(regionEnum)) {
                return;
            }
            const newItem: CompanyMarket = {
                id: 0,
                companyProfileId,
                region: regionEnum,
                regionId: regionId,
            };
            onChange([...markets, newItem]);
        } else {
            // Remove
            const next = markets.filter(m =>
                !(m.regionId === regionId || m.region === regionEnum)
            );
            onChange(next);
        }
    };

    return (
            <FormGroup>
                {MARKET_REGIONS.map(({ value: regionEnum, label }) => {
                    const selected = isRegionSelected(regionEnum);

                    return (
                        <Box key={Number(regionEnum)} sx={{ mb: 1.5 }}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={selected}
                                        onChange={(_, checked) => handleChange(regionEnum, checked)}
                                    />
                                }
                                label={
                                    <Box>
                                        <Typography variant="body1" sx={{ fontWeight: 600 }}>
                                            {label}
                                        </Typography>
                                    </Box>
                                }
                            />
                        </Box>
                    );
                })}
            </FormGroup>
    );
};

export default MarketRegionMultiSelect;
